export function HrSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/hr.svg'"></ng-include>`
    }
}